import {Typography} from '~library/atoms/Typography';

interface LabelProps {
  value: string;
  'data-qa-id'?: string;
}

export const Label = ({value, 'data-qa-id': dataQaId}: LabelProps) => (
  <Typography
    variant="label2"
    classNames="view-invitation__label"
    data-qa-id={dataQaId}
    color="pebble"
    semibold
  >
    {value}
  </Typography>
);
